module.exports = __webpack_public_path__ + "img/noMobile.5cfc8917.png";